import React from 'react';
import {
  Box,
  Button,
  Typography,
  Alert
} from '@mui/material';
import { Google, Microsoft } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { AUTH_BASE_URL } from '../../config';

const LoginForm = () => {
  const { loading, error } = useSelector(state => state.auth);

  const handleGoogleLogin = () => {
    window.location.href = `${AUTH_BASE_URL}/api/auth/google`;
  };

  const handleMicrosoftLogin = () => {
    window.location.href = `${AUTH_BASE_URL}/api/auth/microsoft`;
  };

  return (
    <Box>
      <Typography variant="h5" component="h1" gutterBottom align="center">
        Sign in to Automatrix
      </Typography>

      <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
        Use your @nucleos.com Google or Microsoft 365 account
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Button
        variant="contained"
        color="primary"
        fullWidth
        size="large"
        startIcon={<Google />}
        onClick={handleGoogleLogin}
        disabled={loading}
      >
        Sign in with Google
      </Button>

      <Button
        variant="outlined"
        color="primary"
        fullWidth
        size="large"
        startIcon={<Microsoft />}
        onClick={handleMicrosoftLogin}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        Sign in with Microsoft
      </Button>
    </Box>
  );
};

export default LoginForm;
